<template>
  <header
    :class="{
      'relative z-20 w-full': true,
    }"
    data-testid="Header"
  >
    <div
      :class="{
        'fixed top-0 w-full py-4 md:top-35px': true,
        'text-www-color-neutral-medium-dark': true,
        'shadow-sm shadow-www-color-neutral-light': isScrolled,
        'transition-all duration-300': true,
        'bg-www-color-white': isScrolled,
        'bg-www-color-transparent': !isScrolled,
      }"
    >
      <div
        :class="{
          'mx-auto flex max-w-1920px items-center px-5 lg:px-10': true,
        }"
      >
        <HeaderLogo
          v-bind="props"
          :light="isLightMode && !isScrolled"
        />
        <NavMenu
          v-if="menus"
          v-bind="props"
          :light="isLightMode && !isScrolled"
          :class="{
            'hidden md:flex': true,
          }"
        />

        <div
          :class="{
            'ml-auto': true,
          }"
        >
          <Button
            :class="{
              'hidden font-ptc-Rajdhani md:block lg:uppercase': true,
            }"
            :button-props="{
              style: 'primary',
              _type: 'button',
              text: signupButton.text,
              link: signupButton.link,
            }"
          />
          <button
            :class="{
              'block md:hidden': true,
            }"
            @click="toggleMobilMenu()"
          >
            <PtcIcon
              name="ptc-burger-menu"
              alt="Burger Menu"
              :class="{
                'text-www-color-neutral-medium-dark': true,
                'text-www-color-white': isLightMode && !isScrolled,
              }"
            />
          </button>
        </div>

        <SideMobileHeader
          v-bind="props"
          v-model:is-opened="isOpened"
        />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import type { Header } from '~/sanity/types';
import { useWindowScroll } from '@vueuse/core';

interface Props extends Header {
  light?: boolean;
}

const { y } = useWindowScroll();
const isScrolled = ref(false);
const isLightMode = computed(() => props.light);
const props = defineProps<Props>();
const isOpened = ref(false);
const rs = useResponsive().getDefault();

function toggleMobilMenu() {
  isOpened.value = !isOpened.value;
}
function handleResize() {
  isOpened.value = false;
}

onMounted(() => {
  watch(rs.currentSize, (newVal) => {
    switch (newVal) {
      case 'md':
        handleResize();
        break;
    }
  });
  isScrolled.value = y.value > 15; // Initialize on mount
  watch(y, (newY) => {
    isScrolled.value = newY > 15;
  });
});
</script>

<style></style>
